export enum WidgetTypes {
  last_value = 'LAST_VALUE',
  line_chart = 'TIME_SERIES'
}
